<!-- Add a new component in 3 steps: 
    1. Create a new import statement under the others using the commented out template
    2. Add the component name to the components object in the export default section
    3. Create the html element by typing <COMPONENTNAME> until intellisense finds your component, then hit tab and close the html element with />
     -->
<template>
  <div id="app">
    <!-- <pre>{{ APIStatus }}</pre> -->
    <!-- Step 3 -->
    <!-- Delete this blank-slate and add the new copy when you make one -->
    <!-- <blank-slate /> -->
    <main-header />
    <main-body />
    <modal-window />
    <!-- <data-organizer /> -->
  </div>
</template>

<script>
// Step 1
// import COMPONENTNAME from './components.COMPONENTNAME.vue
import ModalWindow from "./components/ModalWindow.vue";
// import BlankSlate from './components/BlankSlate.vue';
import { eventBus } from "./main.js";
import MainBody from "./components/MainBody.vue";
import MainHeader from "./components/Header.vue";
import DBCommunication from "./services/DBCommunication.js";
// import DataOrganizer from "./services/DataOrganizer.vue";

export default {
  name: "App",
  components: {
    // Step 2
    // Add the component here
    ModalWindow,
    // BlankSlate,
    MainBody,
    // InmateBox,
    MainHeader,
    // DataOrganizer,
  },
  data() {
    return {
      //Used to verify connection to the API backend. To see this, comment out the first commented line in the HTML for this component
      APIStatus: "BAD!",
    };
  },
  methods: {
    //Not used
    DataOrganizerModalOpen() {
      this.$nextTick(() => {
        // Goes to Modal Window (but not used in this app)
        eventBus.$emit("openModalWindow");
      });
    },
    fetchCurrentBookings() {
      DBCommunication.fetchCurrentBookingData()
        .then((response) => {
          this.$store.state.currentInmates = response.data;
          this.$nextTick(() => {
            //This message goes to MainBody.vue
            eventBus.$emit("inmatedatareceived");
          });
          // if (this.$store.state.AllowHistoricData) {
          //   // this.fetchHistoricBookings();
          // }
          //this.initiateRefreshCounter();
        })
        .catch((error) => {
          console.log(error);
          console.log(
            "Error logged above received when fetching current booking data."
          );
        });
    },
    // fetchHistoricBookings() {
    //   DBCommunication.fetchBookingData()
    //     .then((response) => {
    //       this.$store.state.allInmates = response.data;
    //       //DEVELOPMENT
    //       // console.log("Inmate data received!");
    //       // console.log(response.data);
    //       this.$nextTick(() => {
    //         eventBus.$emit("inmatedatareceived");
    //       });
    //       this.$nextTick(() => {
    //         eventBus.$emit("historicdatareceived");
    //       });
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       console.log(
    //         "Error logged above received when fetching historic booking data."
    //       );
    //     });
    // },
    initiateRefreshCounter() {
      setTimeout(() => {
        this.fetchCurrentBookings();
      }, 3600000);
    },
  },
  created() {
    //Grabs the drow down values for the search parameters
    DBCommunication.fetchDropDowns().then((response) => {
      this.$store.state.dropDowns = response.data;
      //DEVELOPMENT
      // console.log("Drop down data received!");
      // console.log(response.data);
      this.$nextTick(() => {
        //Goes to MainBody.vue
        eventBus.$emit("dropdownsreceived");
      });
    });

    this.fetchCurrentBookings();

    DBCommunication.apiHealthCheck().then((response) => {
      this.APIStatus = response.data;
      if (this.APIStatus != "API to front-end communication successful") {
        console.error("Connection to API could not be validated.");
      }
    });

    //Below this is under development
    // let searchTerms = {
    //   FirstName: "Sandra",
    //   LastName: "Ables",
    //   Age: "testAge",
    //   Gender: "testGender",
    //   Race: "",
    //   CustodyStatus: "testCustody",
    // };

    // DBCommunication.fetchHistoricBookingData(searchTerms)
    //   .then((response) => {
    //     // console.log("HERE is the response...");
    //     // console.log(response.data);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    // eventBus.$on("fetchalldata", () => {
    //   this.fetchHistoricBookings();
    // });

    eventBus.$on("makehistoricsearch", () => {
      let searchTerms = this.$store.state.searchTerms;
      if (searchTerms) {
        // console.log(searchTerms);

        DBCommunication.fetchHistoricBookingData(searchTerms)
          .then((response) => {
            // console.log(response.data);
            if (response.data != "Too many results") {
              this.$store.state.historicResults = response.data;
            } else {
              this.$store.state.historicResults = "Too many results";
            }
            //Goes to MainBody.vue
            eventBus.$emit("historicsearchcomplete");
          })
          .catch((error) => {
            console.error("Could not fetch historic data: " + error);
            //Goes to MainBody.vue
            eventBus.$emit("historicsearchfailed");
          });
      }
    });
  },
};
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  /* margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0; */
}

html {
  background-color: white;
  overflow-y: scroll;
  overflow-x: hidden;
  width: auto;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  /* background: #f1f1f1; */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(18, 27, 102);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(68, 87, 152);
}
</style>
